import {
  Autocomplete,
  Box,
  Chip,
  DatePicker,
  FiltrosChips,
  FiltrosDrawer,
  FiltrosSecao,
  TextField,
} from "../../../../components";
import { value } from "../../../../helpers";
import { formatDate } from "../../../../utils";
import {
  PERIODO_PRESETS,
  formatarDataChip,
  intervaloPreset,
} from "../monitor-ordem-servico";

const POPPER_SX = { sx: { zIndex: 9000 } };

function chipsAtivos(filtros, acessosEmpresas, aplicar) {
  const remover = (patch) => aplicar({ ...filtros, ...patch });
  const chips = [
    {
      key: "periodo",
      icon: "ph-calendar-blank",
      label: `${formatarDataChip(filtros.de)} – ${formatarDataChip(
        filtros.ate,
      )}`,
    },
  ];
  if (acessosEmpresas.length > 0) {
    filtros.empresas.forEach((e) =>
      chips.push({
        key: `emp-${e.id}`,
        icon: "ph-buildings",
        label: e.razaoSocial,
        onDelete: () =>
          remover({ empresas: filtros.empresas.filter((x) => x.id !== e.id) }),
      }),
    );
  }
  filtros.prestadores.forEach((p) =>
    chips.push({
      key: `pre-${p.id}`,
      icon: "ph-user",
      label: p.nomeRazaoSocial,
      onDelete: () =>
        remover({
          prestadores: filtros.prestadores.filter((x) => x.id !== p.id),
        }),
    }),
  );
  if (filtros.grupoServico) {
    chips.push({
      key: "grupo",
      icon: "ph-folders",
      label: filtros.grupoServico.descricao,
      onDelete: () => remover({ grupoServico: null }),
    });
  }
  if (filtros.tipoServico) {
    chips.push({
      key: "tipo",
      icon: "ph-wrench",
      label: filtros.tipoServico.descricao,
      onDelete: () => remover({ tipoServico: null }),
    });
  }
  return chips;
}

function MonitorOsFiltros({
  filtros,
  filtrosPadrao,
  onAplicar,
  listas,
  acessosEmpresas,
  draft,
  setDraft,
  open,
  setOpen,
}) {
  const setCampo = (campo, valor) =>
    setDraft((prev) => ({ ...prev, [campo]: valor }));

  const aplicar = () => {
    onAplicar(draft);
    setOpen(false);
  };

  const onChangeData = (campo, date) =>
    setCampo(
      campo,
      date && date !== "Invalid Date" ? formatDate.toSend(date) : "",
    );

  return (
    <>
      <FiltrosChips chips={chipsAtivos(filtros, acessosEmpresas, onAplicar)} />

      <FiltrosDrawer
        open={open}
        onClose={() => setOpen(false)}
        onLimpar={() => setDraft(filtrosPadrao)}
        onAplicar={aplicar}
      >
        <FiltrosSecao titulo="Período" gap={1.5}>
          <Box display="flex" gap={1}>
            <DatePicker
              label="Data Inicial"
              format="dd/MM/yyyy"
              value={value.date(draft.de)}
              onChange={(date) => onChangeData("de", date)}
              sx={{ width: "100%" }}
            />
            <DatePicker
              label="Data Final"
              format="dd/MM/yyyy"
              value={value.date(draft.ate)}
              onChange={(date) => onChangeData("ate", date)}
              sx={{ width: "100%" }}
            />
          </Box>
          <Box display="flex" flexWrap="wrap" gap={0.75}>
            {PERIODO_PRESETS.map((preset) => (
              <Chip
                key={preset.label}
                size="small"
                clickable
                variant="outlined"
                label={preset.label}
                onClick={() =>
                  setDraft((prev) => ({ ...prev, ...intervaloPreset(preset) }))
                }
              />
            ))}
          </Box>
        </FiltrosSecao>

        {acessosEmpresas.length > 0 && (
          <FiltrosSecao titulo="Unidades">
            <Autocomplete
              multiple
              filterSelectedOptions
              options={acessosEmpresas}
              disableCloseOnSelect
              getOptionLabel={(opt) => opt?.razaoSocial ?? ""}
              isOptionEqualToValue={(opt, val) =>
                String(opt?.id) === String(val?.id)
              }
              value={draft.empresas}
              onChange={(_, val) => setCampo("empresas", val)}
              slotProps={{ popper: POPPER_SX }}
              renderInput={(params) => (
                <TextField {...params} label="Unidade(s)" />
              )}
            />
          </FiltrosSecao>
        )}

        <FiltrosSecao titulo="Serviço">
          <Autocomplete
            multiple
            options={listas.prestadores}
            getOptionLabel={(opt) => opt?.nomeRazaoSocial ?? ""}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={draft.prestadores}
            onChange={(_, val) => setCampo("prestadores", val)}
            slotProps={{ popper: POPPER_SX }}
            renderInput={(params) => (
              <TextField {...params} label="Prestador de Serviço" />
            )}
          />

          <Autocomplete
            options={listas.gruposServico}
            getOptionLabel={(opt) => opt?.descricao ?? ""}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={draft.grupoServico}
            onChange={(_, val) => setCampo("grupoServico", val)}
            slotProps={{ popper: POPPER_SX }}
            renderInput={(params) => (
              <TextField {...params} label="Grupo de Serviço" />
            )}
          />

          <Autocomplete
            options={listas.tiposServico}
            getOptionLabel={(opt) => opt?.descricao ?? ""}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={draft.tipoServico}
            onChange={(_, val) => setCampo("tipoServico", val)}
            slotProps={{ popper: POPPER_SX }}
            renderInput={(params) => (
              <TextField {...params} label="Tipo de Serviço" />
            )}
          />
        </FiltrosSecao>
      </FiltrosDrawer>
    </>
  );
}

export default MonitorOsFiltros;
